import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import Media from 'sb-media'

import s from './Pagination.scss'


const Pagination = ({ pagesCount, onClick, forcePage }) => (
  <Media mobile>
    {
      (isMobile) => (
        <ReactPaginate
          forcePage={forcePage}
          activeClassName={s.active}
          containerClassName={s.pagination}
          previousClassName={s.hiddenArrow}
          nextClassName={s.hiddenArrow}
          pageCount={pagesCount}
          marginPagesDisplayed={isMobile ? 1 : 2}
          pageRangeDisplayed={isMobile ? 2 : 5}
          breakLabel={<span className={s.breakLabel}>...</span>}
          onPageChange={onClick}
        />
      )
    }
  </Media>
)

Pagination.propTypes = {
  pagesCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
}

export default Pagination
